
export const locale = {
    lang: 'ru',
    data: {
        NAV: {
            ANNOUNCEMENT: "Извещения",
            BANK_ACCOUNTS: "Банковские счета",
            CRYPTOCURRENCY_ACCOUNTS: "Криптовалютные счета",
            CRYPTO_WITHDRAWAL: "Оплата в криптовалюте",
            DEPOSIT_CRYPTO: "Оплата в криптовалюте",
            DEPOSIT_ELECTRONIC_MONEY: "Оплата Электронными денежными средствами",
            ELECTROINC_MONEY: "Электронные денежные средства",
            EXCHANGE: "Обмен",
            EXCHANGE_SERVICE: "Обмен сервисов",
            E_MONEY_ACCOUNTS: "Счета Электронных денежных средств",
            FRIENDS: "Друзья",
            LOCAL_RECIEVE: "Локальное Поступление",
            MY_WALLETS: "Мои Кошельки",
            NEW_REQUEST: "Новая заявка",
            POINT: "Баллы",
            PROFILE: "Профайл",
            RECIEVE: "Поступление",
            RECIEVEـTC_WALLET: "Поступление с Кошелька ТС",
            SETTING: "Настройки",
            TC_WALLET: " Кошелёк ТС",
            VOUCHER: "Ваучер",
            WITHDRAW_LIST: "История списаний",
            LOCAL_WITHDRAWAL: 'Локальный вывод',
            E_MONEY_WITHDRAWAL: 'Вывод электронными деньгами',
            LOCAL_SEND: 'Локальный вывод',
            DEPOSIT_MONEY_CURRENCY: 'Локальный платеж',
            TC_WALLET_SEND: 'Перевод с Кошелька',
            EXCHANGE_LOCAL_PAYMENT: 'Обмен между своими кошельками внутри системы',
            BUY_LIST: 'История покупок',
            BUY_VOUCHER: 'Покупка Ваучера',
            DASHBOARD: 'Главная',
            DEPOSIT: 'Пополнение',
            MONEY_CURRENCY: 'Метод оплаты',
            WALLETS: 'Кошелёк',
            WITHDRAW: 'Вывод',
            WITHDRAWAL: 'Вывод',
            SUPPORTS: 'Поддержка',
            SUPPORT: 'Поддержка',
            TICKETS: 'Обращение',
            SEND: 'Отправление ',
            FAQ: 'FAQ',
            MY_ACCOUNTS: 'Мои Счета',
            TC_ACCOUNTS: 'Счета ТС',
            TRANSACTIONS: 'Транзакции'
        },
        REQUEST: {
            'NOTIFY': {
                'TITLE': {
                    'POINT': 'Списание баллов',
                    'VOUCHER': 'Ваучер',
                    'DEPOSIT_MONEY_CURRENCY': 'Пополнение (Локальный платёж)',
                    'DEPOSIT_E_MONEY': 'Пополнение (Электронные деньги)',
                    'WITHDRAWAL_MONEY_CURRENCY': 'Списание (Локальный платёж)',
                    'WITHDRAWAL_E_MONEY': 'Списание (Электронные деньги)',
                    'SEND_OTHER_WAY': 'Перевод',
                    'SEND_TC_WALLET': 'Перевод',
                    'RECEIVE_OTHER_WAY': 'Получение',
                    'RECEIVE_TC_WALLET': 'Получение (Кошелёк)',
                    'EXCHANGE_MONEY_CURRENCY': 'Обмен (Кошелёк)'
                },
                'NOTIFICATION': {
                    'TITLE': {
                        'MESSAGE': 'Сообщение в заявке Депозит'
                    },
                    'BODY': {
                        'DONE': 'Заявка под номером {{0}} успешно выполнена. Ваш Кошелёк {{1}} пополнен.',
                        'REJECT': 'Заявка под номером {{0}} отклонена.',
                        'REFUND': 'Заявка под номером {{0}} возмещена.',
                        'MESSAGE': 'Оператор отправил сообщение в заявке с номером {{0}}.'
                    }
                }
            },
            COMMISSION: {
                REQUESTED_AMOUNT: 'Сумма заявки',
                FIXED_AMOUNT: 'Фиксированная сумма',
                CHARGE_AMOUNT: 'Сумма пополнения',
                SELL_AMOUNT: 'Сумма пополнения',
                BUY_AMOUNT: 'Сумма Покупки',
                PAY_AMOUNT: 'Сумма к оплате',
                SEND_AMOUNT: 'Сумма к отправке',
                WITHDRAWAL_AMOUNT: 'Сумма к списанию',
                CONVERTED_AMOUNT: 'Сумма обмена',
                UPDATE_TIME: 'Обновление',
                COMMISSION: 'Комиссия',
                EXCHANGE_RATE: 'Курс обмена',
                INITIAL_COST: 'Первоначальный взнос',
                BONUS_FIXED_AMOUNT: 'Фиксированная сумма',
                BONUS: 'Бонус',
                MINIMUM_COMMISION: 'Минимальная комиссия',
                MINIMUM_BONUS: 'минимальный бонус',
                MAXIMUM_COMMISION: 'Максимальная комиссия',
                MAXIMUM_BONUS: 'максимальный бонус',
                POINT: 'Баллы',
                GET_AMOUNT: 'Сумма к получению',
                GET_AMOUNT_THIRD_PARTY: 'Сумма к получению Третьим Лицом',
                CALCULATED_AMOUNT: 'Сумма с учётом комиссии',
                CALCULATED_AMOUNT_BUNOS: "Сумма с учетом бонуса"
            },
            CRYPTO_NAME: "Название криптовалюты",
            CRYPTOCURRENCY: "Криптовалюта",
            PAYMENT_AMOUNT: 'Сумма платежа',
            BY_LOCAL_PAYMENT: "Посредством локального платежа",
            CONVERSATION_CLODES: "Данный диалог закрыт",
            CRYPTO: "Криптовалюта",
            CRYPTO_PAYMENT: "Оплата Криптовалютой",
            SERVICE_PAYMENT: "Сервисный платёж",
            WITH_CRYPTOCURRENCY: "Криптовалютой",
            WITH_EMONEY: "Электронными денежными средствами",
            CHANGE_STATUS_DATE: 'Дата изменения статуса',
            DETAIL: 'Подробности',
            DONT_HAVE_WALLET_NUMBER: 'У меня нет номера Кошелька',
            ELECTRONIC_MONEY_PAYMENT: 'Оплата Электронными деньгами',
            ELECTRONIC_MONEY: 'Электронные деньги',
            ELECTRONIC_MONEY_NAME: 'Название Электронных денег',
            EXPERT_DESCRIPTION: 'Ответ эксперта',
            END: 'Завершение',
            LOCAL_PAYMENT: 'Локальный платёж',
            MORE_INFO: 'Дополнительная информация',
            PAY_AMOUNT: 'Сумма к оплате',
            PAY_CURRENCY: 'Валюта платежа',
            REQUEST_INFO: 'Информация о заявке',
            REQUESTS: 'Заявки',
            SELECT_FRIEND: 'Выбрать друга',
            TRACKING_NUMBER: 'Номер заявки',
            THIRD_PARTY_WALLET: 'Кошелёк Третьего Лица',
            VERIFY: 'Подтвердить',
            WALLET: 'Кошелёк',
            WAITING: 'Ожидание',
            TRANSACTION_AMOUNT: 'Сумма транзакции',
            DEPOSIT: {
                CHARGE_AMOUNT: 'Сумма пополнения',
                CHARGE_TYPE: 'Способ пополнения',
                ALERT: {
                    WAIT_FOR_GET_CASH_PAY_DETAIL: 'Ваша заявка успешно зарегистрирована. Пожалуйста, ожидайте, наш Эксперт отправит Вам сообщение либо напрямую свяжется с Вами. Для завершения процедуры пополнения Кошелька после получения необходимых сведений и передачи суммы, пожалуйста, зарегистрируйте данные своего платежа.',
                    WAIT_FOR_PROCESS_PAYMENT_REQUEST: 'Уважаемый Пользователь, после рассмотрения и подтверждения нашими Экспертами зарегистрированного Вами платежа, указанный Кошелёк будет пополнен.'
                },
                MONY_CURRENCY: 'Виды пополнения',
                DEPOSIT_INFO: 'Данные платежа',
                NOTIFY: {
                    'NOTIFICATION': {
                        'TITLE': {
                            'MESSAGE': 'Сообщение в заявке на пополнение',
                            'REJECTED': 'Отклонение платежа',
                            'ACCOUNT_ASSIGNED': 'Сведения о платеже'
                        },
                        'BODY': {
                            'REJECTED': 'Ваша заявка под номером {{0}} отклонена.',
                            'DONE': 'Заявка под номером {{0}} успешно выполнена. Ваш Кошелёк пополнен на сумму в {{1}}.',
                            'MESSAGE': 'Эксперт отправил сообщение в заявке с номером {{0}}.',
                            'REFUND': 'Заявка под номером {{0}} возмещена.',
                            'ACCOUNT_ASSIGNED': 'Сведения о банковском счёте для выполнения платежа заявки на пополнение под номером {{0}} зарегистрированы.'
                        }
                    }
                },
                STEPS_HINT: {
                    SELECT_WALLET: 'Выберите Кошелёк для пополнения.',
                    ENTER_EMONEY_AMOUNT: 'Введите сумму, на которую хотите пополнить Кошелёк.',
                    ENTER_CRYPTO_AMOUNT: 'Введите сумму, на которую хотите пополнить Кошелёк.',
                    ENTER_AMOUNT: 'Введите сумму, на которую хотите пополнить Кошелёк.',
                    ACCEPT_INFO: 'Для регистрации Заявки проверьте и подтвердите верность информации.',
                    BANK_WAITING: 'Ваша Заявка успешно зарегистрирована, пожалуйста, ожидайте получения данных счёта для выполения оплаты.',
                    CASH_WAITING: 'Ваша Заявка успешно зарегистрирована, пожалуйста, ожидайте получения данных о месте передачи оплаты.',
                    BANK_PAYMENT: 'Пожалуйста, перечислите сумму на указанный счёт.',
                    CASH_PAYMENT: 'После передачи денег зарегистрируйте сведения об оплате.',
                    ONLINE_PAYMENT: 'Ваша Заявка успешно зарегистрирована, пожалуйста,выберите свой банк и перечислите сумму в режиме Онлайн.',
                    CREDIT_ENTER_PAYMENT_INFO: ' Выберите Кошелёк для пополнения.',
                    PAYMENT_EMONEY: 'Пожалуйста, перечислите сумму на указанный счёт, затем зарегистрируйте данные своего платежа.'
                }
            },
            WITHDRAWAL: {
                ACCOUNT_INFORMATION: 'Данные счёта',
                DEPOSIT_TO_MY_ACCOUNT: 'Зачислить на мой счёт',
                DEPOSIT_TO_THIRD_PARTY_ACCOUNT: 'Зачислить на счёт Третьего Лица',
                LOCAL_PAYMENT: 'Локальный платёж',
                RECEIVER_NAME: 'Имя Получателя',
                RECEIVER_NAME_HINT: 'Введите имя получателя',
                SELECT_ACCOUNT: 'Выбрать счёт',
                E_MONEY_PAYMENT: 'Платёж электронными деньгами',
                E_MONEY_WITHDRAWAL: 'Вывод Электронных денег',
                LOCAL_WITHDRAWAL: 'Локальное списание',
                BANK_ACCOUNT: 'Банковский счёт ',
                LOCATION: 'Место получения суммы',
                TO_CRYPTOCURRENCY_ACCOUNT: "Перечисление на  криптовалютный счёт",
                TO_EMONEY_ACCOUNT: "Перечисление на  счет Электронных денежных средств",
                NOTIFY: {
                    NOTIFICATION: {
                        TITLE: {
                            MESSAGE: 'Сообщение в заявке на списание'
                        },
                        BODY: {
                            DONE: 'Заявка под номером {{0}} успешно выполнена. Сумма в {{1}} списана с Вашего Кошелька.',
                            REJECT: 'Ваша заявка под номером {{0}} отклонена.',
                            REFUND: 'Заявка под номером {{0}} возмещена.',
                            MESSAGE: 'Эксперт отправил сообщение в заявке с номером {{0}}.',
                            REJECTED: "Заявка под номером {{0}} отклонена."
                        }
                    }
                },
                STEPS_HINT: {
                    SELECT_EMONEY_ACCOUNT: 'Выберите свой cчёт электронных денежных средств, на который хотите зачислить средства.',
                    SELECT_CRYPTO_ACCOUNT: ' Выберите свой  криптовалютный cчёт , на который хотите зачислить средства.',
                    SELECT_WALLET: ' Выберите Кошелёк, с которого хотите списать средства.',
                    ENTER_AMOUNT: 'Введите Сумму к списанию с Кошелька.',
                    ACCEPT_INFO: 'Для регистрации Заявки проверьте и подтвердите верность информации.',
                    SELECT_BANK_ACCOUNT: 'Выберите свой банковский счет для перечисления.',
                    SELECT_LOCATION: 'Выберите город, в котором хотите получить деньги.',
                    ENTER_RECEIVER_NAME: 'Введите имя и фамилию Получателя.',
                },
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: 'Сумма списания не может быть больше остатка в Кошельке.'
                }
            },
            SEND: {
                ENTER_ALERT_INFORMATION: 'Пожалуйста, внесите запрошенные сведения.',
                INTERNAL_TRANSFER: 'Внутренний перевод',
                LOCAL_SEND: 'Локальный платёж',
                RECEIVER: 'Получатель',
                RECEIVER_FULL_NAME: 'Имя Получателя',
                RECEIVER_USER_NAME: 'Логин Получателя',
                SEND: 'Отправить',
                SEND_DATE: 'Дата перевода',
                SEND_AMOUNT: 'Сумма перевода',
                SEND_FROM_TC_WALLET: 'Отправить с Кошелька ТС',
                SEND_TYPE: 'Способ перевода',
                TC_TO_TC: 'С ТС на ТС',
                PAY_AMOUNT: "Сумма платежа",
                TO_TC: "На ТС",
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: 'Сумма перевода не может быть больше остатка'
                },
                ALERT: {
                    SEND_TC_WALLET_SUCCESS: 'Перевод на Кошелёк Получателя успешно выполнен',
                    WAIT_FOR_GET_CASH_PAY_DETAIL: 'Ваша заявка успешно зарегистрирована. Пожалуйста, ожидайте, наш Эксперт отправит Вам сообщение либо напрямую свяжется с Вами. Для завершения процедуры пополнения Кошелька Получателя после получения необходимых сведений и передачи суммы, пожалуйста, зарегистрируйте данные своего платежа.',
                    WAIT_FOR_PROCESS_PAYMENT_REQUEST: 'Уважаемый Пользователь, после рассмотрения и подтверждения зарегистрированного Вами платежа нашими Экспертами, указанный Кошелёк Получателя будет пополнен.'
                },
                TC_WALLET_SEND: 'Оплата с Кошелька',
                NOTIFY: {
                    'NOTIFICATION': {
                        TITLE: {
                            ACCOUNT_ASSIGNED: 'Запросить платежную информацию'
                        },
                        'BODY': {
                            'TO_ANOTHER': 'Заявка под номером {{0}} успешно выполнена. Сумма в {{1}} отправлена {{2}}.',
                            'REFUND': 'Заявка под номером {{0}} возмещена.',
                            'REJECTED': 'Ваша заявка под номером {{0}} отклонена.',
                            'DONE': 'Заявка под номером {{0}} успешно выполнена. Сумма в {{1}} зачислена на счёт Получателя.',
                            ACCOUNT_ASSIGNED: 'Информация о банковском счете для регистрации платежного запроса была зарегистрирована с номером отслеживания {{0}}'
                        }
                    }
                },
                STEPS_HINT: {
                    SELECT_THIRD_PARTY_WALLET: ' Выберите Кошелёк Получателя, на который хотите отправить средства.',
                    ENTER_SEND_AMOUNT: 'Введите Сумму,  которую хотите отправить.',
                    ACCEPT_INFO: 'Для регистрации Заявки проверьте и подтвердите верность информации.',
                    BANK_WAITING: 'Ваша Заявка успешно зарегистрирована, пожалуйста, ожидайте получения данных счёта для выполения оплаты.',
                    BANK_PAYMENT: 'Пожалуйста, перечислите сумму на указанный счёт.',
                    CASH_WAITING: 'Ваша Заявка успешно зарегистрирована, пожалуйста, ожидайте получения данных о месте оплаты.',
                    CASH_PAYMENT: 'После передачи денег зарегистрируйте сведения об оплате.',
                    ENTER_PAYMENT_INFO: 'Пожалуйста,введите сведения об оплате.',
                    ONLINE_PAYMENT: 'Ваша Заявка успешно зарегистрирована, пожалуйста,выберите свой банк и перечислите сумму в режиме Онлайн.'
                },
                TC_WALLET: {
                    NOTIFY: {
                        NOTIFICATION: {
                            BODY: {
                                RECEIVE: 'Получена Сумма в {{0}} от Пользователя {{1}}, номер заявки {{2}}.'
                            }
                        }
                    },
                    STEPS_HINT: {
                        SELECT_WALLET: 'Выберите свой Кошелёк, с которого хотите списать средства.',
                        SELECT_THIRD_PARTY_WALLET: 'Выберите Кошелёк Получателя, на который хотите отправить средства.',
                        ENTER_SEND_AMOUNT: 'Введите Сумму,  которую хотите отправить.',
                        ACCEPT_INFO: 'Для регистрации Заявки проверьте и подтвердите верность информации.',
                    },
                }
            },
            RECEIVE: {
                'BE_ARCHIVED': 'Архивировать',
                'RECIEVE_INFO': 'Информация о получении средств',
                'ARCHIVE': 'Архив',
                'ARCHIVED': 'Архивировано',
                'TO_WALLET': 'На Кошелёк',
                'FROM_WALLET': 'С Кошелька',
                'FROM_USER': 'От Пользователя',
                'AMOUNT': 'Сумма',
                'ARCHIVED_DATE_FROM': 'Архивировано с',
                'ARCHIVED_DATE_TO': 'Архивировано по',
                'ARCHIVED_SUCCESSFULLY': 'Указанная транзакция успешно архивирована',
                'MORE_INFO': 'Дополнительная информация',
                'RECIVE': 'Получение',
                'SENDER': 'Отправитель',
                'RECEIVE_DATE': 'Дата получения',
                'OTHER_WAY': {
                    'NOTIFY': {
                        'NOTIFICATION': {
                            'BODY': {
                                'TO_ANOTHER': 'Получена Сумма в {{0}} от Пользователя {{1}}, номер заявки {{2}}.'
                            }
                        }
                    }
                }
            },
            EXCHANGE: {
                CHANGE: 'Изменение',
                EXCHANGE: 'Обмен',
                ELECTRONIC_MONEY_TO_ELECTRONIC_MONEY: 'Обмен электронных денег',
                EXCHANGE_AMOUNT: 'Сумма обмена',
                LOCAL_PAYMENT: 'Локальный платёж',
                PAY_SERVICE: 'Электронные деньги к оплате',
                SELECT: 'Выбрать',
                TC_TO_TC: 'С ТС на ТС',
                EXCHANGE_TYPE: 'Способ обмена',
                SELECT_CURRENCY: 'Выберите валюту',
                EXCHANGE_DATE: 'Дата обмена',
                EXCHANGE_INFO: 'Информация об обмене',
                TC_WALLET: 'Кошелёк ТС',
                CURRENCY: 'Валюта обмена',
                SELECTED_PAY_SERVICE: 'Оплата Электронными деньгами',
                GET_SERVICE: 'Выбрать к оплате',
                ELECTRONIC_MONEY: 'Электронные деньги',
                SELECTED_GET_SERVICE: 'Выбрать к получению',
                NEW_EXCHANGE: 'Новый обмен',
                SELECT_PAY_SERVICE: 'Выбрать электронные деньги к оплате',
                SELECT_GET_SERVICE: 'Выбрать электронные деньги к получению',
                NO_HAVE_ANY_GET_SERVICE: 'Платёжная система к получению отсутствует',
                EXCHANGE_SERVICE: "Обмен сервисов",
                SUBSERVICE: "Вид сервиса",
                NOTIFY: {
                    'NOTIFICATION': {
                        'TITLE': {
                            'MESSAGE': 'Сообщение в заявке на Обмен'
                        },
                        'BODY': {
                            'DONE': 'Заявка под номером {{0}} успешно выполнена. Сумма в {{1}} зачислена на конечный счёт .',
                            'REJECTED': 'Ваша заявка под номером {{0}} отклонена.',
                            'REFUND': 'Заявка под номером {{0}} возмещена.',
                            'MESSAGE': 'Эксперт отправил сообщение в заявке с номером {{0}}.'
                        }
                    }
                },
                STEPS_HINT: {
                    SELECT_WALLET: 'Выберите свой Кошелёк, с которого хотите списать средства.',
                    SELECT_WALLET_TO_TRANSFER: 'Выберите свой Кошелёк , на который хотите перевести средства.',
                    ENTER_EXCHANGE_AMOUNT: 'Введите Сумму,  которую хотите обменять.',
                    ACCEPT_INFO: 'Для регистрации Заявки проверьте и подтвердите верность информации.',
                    SELECT_PAY_GET_SERVICE: 'Выберите сервис к оплате/к получению для выполнения обмена',
                    ENTER_ACCOUNT_INFO: 'Введите сведения своего счёта либо счёта Третьего Лица',
                    PAYMENT: 'Пожалуйста, перечислите сумму на указанный счёт, затем зарегистрируйте данные своего платежа.'
                },
                VALIDATION: {
                    REQUESTED_AMOUNT_IS_MORE_THAN_BALANCE: 'Сумма обмена не может быть больше остатка в Кошельке.'
                }
            },
            VOUCHER: {
                VOUCHER_NAME: 'Название ваучера',
                VOUCHER_TYPE: 'Вид Ваучера',
                UNIT_PRICE: 'Номинал  Ваучера',
                QUANTITY: 'Количество Ваучеров к покупке',
                USER_PRICE: 'Стоимость',
                TOTAL_PRICE: 'Общая стоимость',
                UNIT_COMMISSION: 'Комиссия за покупку единицы',
                COMISSION: 'Комиссия ',
                EXCHANGE_RATE: 'Курс обмена',
                VOUCHER_ITEM: 'Вид Ваучера',
                MIN_QUANTITY: 'Минимальное количество',
                MAX_QUANTITY: 'Максимальное количество',
                VOUCHER: 'Ваучер',
                TOTAL_COMISSION: 'Общая комиссия',
                SERIAL_NUMBER: 'Серийный номер',
                AMOUNT: 'Сумма',
                PURCHASED_VOUCHERS: 'Купленные ваучеры',
                PURCHASED_INFO: 'Информация о покупке',
                PURCHASED_DATE: 'Дата покупки',
                WOULD_RECEIVE_VOUCHER_INFO_EMAIL: 'Отправить информацию о Ваучере на электронную почту',
                STEPS_HINT: {
                    SELECT_WALLET: 'Выберите Кошелёк, с которого хотите оплатить покупку  Ваучера.',
                    NUMBER_OF_PURCHASE: 'Введите необходимое количество выбранного к покупке Ваучера.',
                    ACCEPT_INFO: 'Для регистрации Заявки проверьте и подтвердите верность информации.',
                }
            },
            POINTS: {
                'TO_TC_WALLET': 'Зачислить на Кошелёк ТС',
                'WITHDRAW_DATE': 'Дата списания',
                'WITHDRAWAL_INFO': 'Информация о списании',
                'WHITDRAW_POINT': 'Списание баллов',
                'TRANSACTION_NAME': 'Вид транзакции',
                'GET_AMOUNT': 'Сумма к получению',
                'NUMBER_OF_POINT': 'Количество баллов',
                'EACH_1000_POINT': 'Каждые 1000 баллов',
                'MY_POINTS': 'Мои баллы',
                'MIN_NUM_FOR_WITHDAWAL': 'Минимальное количество баллов, подлежащее списанию',
                'INVOICE_TYPE': 'Обмен баллов на деньги',
                'EACH': 'Каждые ',
                'WITHDRAWAL_POINTS': 'Баллы к списанию',
                'NUMBER_OF_POINTS': 'Количество баллов',
                'POINTS': 'Баллы ',
                'TOTAL_POINTS': 'Общее количество баллов',
                'WALLET': 'Кошелёк',
                'CHANGE_STATUS': 'Статус',
                'TRANSACTION_TYPE': 'Вид транзакции',
                'CHANGE_TYPE': 'Изменение статуса',
                'WITHDRAWAL': 'Списание баллов',
                STEPS_HINT: {
                    SELECT_WALLET: ' Выберите Кошелёк для зачисления суммы.',
                    POINT_WITHDRAWAL: 'Введите необходимое число баллов к списанию.',
                    ACCEPT_INFO: 'Для регистрации Заявки проверьте и подтвердите верность информации.',
                },
                ALERT: {
                    IS_LOWER_THAN_MIN: 'Текущее число Ваших баллов меньше минимального количества баллов, подлежащего списанию.'
                },
                VALIDATION: {
                    MIN_POINT_FOR_WITHDRAWAL: 'Минимальное количество баллов, подлежащее списанию:'
                }
            },
            'CONFIRMATION': {
                'CONFIRMATION_CODE': 'Код подтверждения',
                'CONFIRMATION_HELP_EMAIL': 'Для регистрации заявки введите код, отправленный на Ваш Email.',
                'CONFIRMATION_HELP_SMS': 'Для регистрации заявки введите код, отправленный на Ваш мобильный телефон.',
                'SEND_CODE': 'Отправить код ',
                'SECURITY_CODE': 'Код подтверждения'
            },
            'PAYMENT': {
                'ACCOUNT_INFO': 'Данные счёта',
                'ADD': 'Регистрировать данные платежа',
                'AMOUNT': 'Сумма',
                'AMOUNT_MUST_PAY': 'Пожалуйста, перечислите сумму в {{value}} на счёт ТС и затем зарегистрируйте данные своего платежа.',
                'AMOUNT_MUST_PAY_CASH': 'Пожалуйста, передайте сумму в {{value}} в указанном месте и затем зарегистрируйте данные своего платежа.',
                'AMOUNT_OUT_STANSING': 'Остаток от суммы',
                'CREATED_DATE': 'Дата регистрации',
                'INTER_PAYMENT_INFO': 'Пожалуйста, введите сведения о платеже',
                'MY_PAYMENTS': 'Мои платежи',
                'NEW_PAYMENT': 'Новый платёж',
                'PAY_AMOUNT': 'Сумма к оплате',
                'PAYMENT_AMOUNT': 'Сумма платежа',
                'PAYMENT_DETAILS': 'Подробности платежа',
                'PAYMENT': 'Оплата',
                'PAYMENT_DATE': 'Дата платежа',
                'PAYMENT_LOCATION': 'Место оплаты',
                'PAYMENT_INFO': 'Сведения о платеже',
                'PAYMENT_REF_NUMBER': 'Регистрационный номер',
                'PAYMENT_HISTORY': 'История платежей ',
                'PAY_NOW': 'Оплатить',
                'REFRENCE_NUMBER': 'Номер заявки',
                'SENDER': 'Отправитель',
                'SENDER_ACCOUNT_NUMBER': 'Сведения о счёте',
                'SEND_BY_THIRD_PARTY': 'Оплата со счёта Третьего Лица',
                'SUM_OF_TOTAL_AMOUNT_APPROVED': 'Общая подтверждённая сумма',
                'TC_PAYMENTS': 'Платежи ТС',
                'TOTAL_WAITING_FOR_CONFIRMATION': 'Общая сумма, ожидающая подтверждения',
                'TC_ACCOUNT': 'Счёт ТС',
                'TC_SERVICE_ACCOUNT': 'Счёт ТС',
                'TOTAL_AMOUNT_PAID': 'Общая сумма к оплате',
                'YOUR_ACCOUNT': 'Ваш счёт',
                'YOUR_SERVICE_ACCOUNT': 'Ваш счёт',
                'E_MONEY': {
                    'NOTIFY': {
                        'NOTIFICATION': {
                            'TITLE': {
                                'REJECTED': 'Отклонение платежа'
                            },
                            'BODY': {
                                'REJECTED': 'Платёж заявки на пополнение под номером {{0}} отклонён.'
                            }
                        }
                    }
                },
                'BANK': {
                    'NOTIFY': {
                        'NOTIFICATION': {
                            'TITLE': {
                                'REJECTED': 'Отклонение платежа',
                                'ACCOUNT_ASSIGNED': 'Сведения о платеже'
                            },
                            'BODY': {
                                'REJECTED': 'Платёж заявки на пополнение под номером {{0}} отклонён.',
                                'ACCOUNT_ASSIGNED': 'Сведения о банковском счёте для выполнения платежа заявки на пополнение под номером {{0}} зарегистрированы.'
                            }
                        }
                    }
                },
                'CASH': {
                    'NOTIFY': {
                        'NOTIFICATION': {
                            'TITLE': {
                                'REJECTED': 'Отклонение платежа'
                            },
                            'BODY': {
                                'REJECTED': 'Платёж заявки на пополнение под номером {{0}} отклонён.'
                            }
                        }
                    }
                },
                'ALERT': {
                    'CANT_DELETE_PAYMENT': 'Вы не можете удалить этот платёж.'
                }
            },
            ALERT: {
                ADD_NEW_BANK: 'Хотите добавить новый банковский счёт?',
                AMOUNT_MUST_BE_INTEGER: 'Введите сумму цифрами',
                AMOUNT_PRECISION_ERROR: 'Десятичная шкала должна быть менее {{vaule}}.',
                REJECTED_TEXT: 'Ваша заявка отклонена',
                WAITING_FOR_INFORMATION: 'Пожалуйста, дождитесь получения данных платежа',
                WAIT_FOR_GET_BANK_ACCOUNT_DETAILS: 'Ваша заявка успешно зарегистрирована, в скором времени в Уведомлениях Вам будут отправлены данные банковского счёта для зачисления суммы. После осуществления платежа, пожалуйста, зарегистрируйте сведения о нём, чтобы сумма была зачислена на Ваш Кошелёк. ',
                WAIT_FOR_PROCESS_WITHDRAW_PAYMENT_REQUEST: 'Уважаемый Пользователь, после рассмотрения и подтверждения Вашей заявки нашими экспертами, сумма будет зачислена на указанный счёт.',
                ONLINE_SUCCESS: 'Ваш платёж успешно выполнен, Кошелёк пополнен.',
                MIN_ORDER: 'Минимальная сумма составляет {{vaule}}.',
                MAX_ORDER: 'Максимальная сумма составляет {{vaule}}.',
                PAYMENT_ADD_SUCCESSFUL: 'Ваш платёж успешно зарегистрирован.',
                CONFIRM_PAYMENT_DELETE: 'Вы уверены, что хотите удалить этот платёж на сумму {{value}}?',
                PAYMENT_DELETED_SUCCESS: 'Указанный платёж успешно удалён.',
                CONFIRM_REQUEST_DELETE: 'Вы уверены, что хотите удалить эту заявку?',
                REQUEST_DELETED_SUCCESS: 'Ваша заявка успешно удалена.',
                CAN_SEND_MESSAGE: 'Отправление сообщений будет активировано после регистрации заявки.',
                THERE_IS_NO_MESSAG: 'Сообщений нет',
                COMMISION_DATA_NOT_FOUND: 'Информация о Комиссии не найдена',
                COMMISSION_DATA_IS_NOT_DEFIENED: 'Cведения о Комиссии не определены.',
                CURRENCY_LIST_IS_NOT_FOUND: 'Список валют не найден',
                CURRENCY_EXCHANGE_RATE_LIST_NOT_FOUND: 'Курсы на обмен валют не найден',
                THERE_IS_NO_MESSAGE: 'Сообщений нет',
                REQUEST_WAS_NOT_FOUND: 'Указанная заявка не найдена',
                PAYMENT_TEXT: 'Ваша заявка находится на стадии оплаты',
                PROCESSING_TEXT: 'Указанная заявка не найдена в процессе рассмотрения',
                WHAIT_FOR_ASSIGN_PAYMENT: 'Пожалуйста, ожидайте получения сведений платежа нашими экспертами',
                WAIT_TILL_ACCEPT_PAYMENT: 'Пожалуйста, ожидайте подтверждения сведений платежа нашими экспертами',
                WAIT_FOR_PROCESS_CREDIT_REQUEST: 'Уважаемый Пользователь, после рассмотрения и подтверждения отправленных Вами сведений платежа нашими экспертами, указанный Кошелёк будет пополнен.',
                USE_V1: 'Уважаемый Пользователь, для выполнения этой заявки, обратитесь к старой версии сайта.',
                WAITING_MESSAGE: 'Уважаемый Пользователь, пожалуйста, ожидайте, пока наши эксперты рассмотрят Вашу заявку.',
                WAIT_FOR_PROCESS_WITHDRAW_CASH_PAYMENT: 'Уважаемый Пользователь, после рассмотрения и подтверждения Вашей заявки нашими экспертами, сумма будет передана указанному получателю.',
                WITHDRAWAL_POINT_SUCCESS: 'Списание баллов успешно выполнено, сумма зачислена на указанный Кошелёк.',
                BETWEEN_MY_WALLET_SUCCESS: 'Перевод средств между указанными Кошельками успешно выполнен.',
                NEED_VERIFY: "Для получения доступа к данному разделу сначала необходимо пройти этапы верификации личных данных"
            },
            'ACCEPT_ABOVE_INFO': 'Вышеуказанные сведения принимаю',
            'QUANTITY': 'Количество',
            'ARCHIVE_DATE': 'Дата архивирования',
            'ARCHIVE': 'Архивировать',
            'MY_WALLET': 'Мой Кошелёк',
            'OTHER_WAYS_TRANSMISSION': 'Перевод средств иным способом',
            'TRANSFER_DATE': 'Дата перевода средств',
            'WALLET_NOT_FOUND': 'Кошелёк не найден',
            'DEPOSIT_PAYMENT_TYPE': 'Способ пополнения',
            'RECEIVE_CURRENCY': 'Валюта к получению',
            'WITHDRAWAL_AMOUNT': 'Сумма к списанию',
            'MONEY_CURRENCY': 'Локальный платёж',
            'SELL_AMOUNT': 'Сумма к продаже',
            'BALANCE': 'Остаток',
            'CHANGE_STATE': 'Изменение статуса',
            'BANK': 'Банк',
            'FRIEND': 'Друг',
            'CALCULATED_AMOUNT_ALONE': 'Рассчитанная сумма',
            'CALCULATED_AMOUNT_BUNOS': 'Сумма с учётом бонуса',
            'CHARGE_AMOUNT': 'Сумма к пополнению',
            'AMOUNT': 'Сумма к пополнению',
            'BUY_AMOUNT': 'Сумма к покупке',
            'RECEIVER': 'Получатель',
            'PAY_ACCOUNT': 'Оплатить со счёта',
            'DECIMAL_SCALE': 'Десятичная шкала',
            'ACCOUNT_INFO': 'Реквизиты счёта',
            'REQUEST_DATE': 'Дата заявки',
            'SEND_DATE': 'Дата перевода',
            'DATE': 'Дата',
            'ELECTROINC_MONEY': 'Электронные деньги',
            'EXCHANGE_RATE': 'Курс',
            'THIRD_PARTY_INFORMATION': 'Данные Третьего Лица',
            'INITIAL_COST': 'Первоначальный взнос',
            'COMMISION': 'Комиссия',
            'REQUEST_LIST': 'Список заявок',
            'LOCATION': 'Место получения суммы',
            'GET': 'К получению',
            'REFRENCE_NUMBER': 'Номер заявки',
            'MY_PAYMENT': 'Мои платежи',
            'MINIMUM_COMMISION': 'Минимальная комиссия',
            'GET_AMOUNT': 'Сумма к получению',
            'REQUESTED_DATE': 'Дата заявки',
            'DEPOSIT_INFORMATION': 'Данные платежа',
            'DIGITAL_CURRENCY': 'Цифровая валюта',
            'SERVICE_NAME': 'Название',
            'YOUR_REQUEST_SUBMITTED': 'Ваша заявка успешно зарегистрирована',
            'WAYS_SEND_TO_OTHERS': 'Способы перевода средств другим пользователям',
            'RECIEVE_TYPE': 'Способ получения',
            'WITHDRAWAL_TYPE': 'Способ списания',
            'RECIEVE_CURRENCY': 'Валюта к получению',
            'PAY_SERVICE': 'Платёжная система к оплате',
            'GET_SERVICE': 'Платёжная система к получению ',
            'EXCHANGE_TEXT': 'Перечисление',
            'POINT': 'Баллы',
            'EXCHANGE_TYPE': 'Тип обмена',
            'PAYMENT_TYPE': 'Способ оплаты',
            'TOTAL_AMOUNT': 'Общая сумма к оплате',
            'MIN_AMOUNT': 'Минимальная сумма ',
            'MAX_AMOUNT': 'Максимальная сумма ',
            'MAXIMUM_COMMISION': 'Максимальная комиссия',
            'THIRD_PARTY': 'Третье Лицо',
            'SECURITY': 'Безопасность ',
            'SEND_TO_THIRD_PARTY_TC_WALLET': 'Отправить на Кошелёк друга',
            'SEND_TO_THIRD_PARTY': 'Зачислить на счёт Третьего Лица',
            'PAYMENT_INFO_WILL_SEND_VIA_NOTIFICATION': 'Сведения о платеже будут отправлены Вам в Уведомлениях',
            'WHEN_RECEIVE_PAYMENT_INFO': 'После получения сведений о платеже следуйте дальнейшим инструкциям.',
            'MESSAGE_PLACE_HOLDER': 'Введите сообщение',
            'BONUS_FIXED_AMOUNT': 'Фиксированная сумма',
            'BONUS': 'Бонус',
            'NO_PAYMENT': 'Зарегистрированные платежи отсутствуют',
            'FROM_WALLET': 'С Кошелька',
            'TO_WALLET': 'На Кошелёк'
        },
        DASHBOARD: {
            CURRENCY: "Валюта",
            EXCHANGE_RATE: {
                SELL: 'Покупка',
                BUY: 'Продажа',
                BOTH_EXCHANGE_RATE: "Обменный курс фиат на криптовалюту",
                CRYPTO_EXCHANGE_RATE: "Обменный курс криптовалют",
                EXCHANGE_RATE: "Обменный курс",
                FIAT_EXCHANGE_RATE: "Обменный курс фиатных валют",
            },
            POINTS: {
                WITHDRAW: 'Вывод',
                TRANSACTIONS: 'Транзакции',
                MY_POINTS: 'Мои баллы'
            },
            TRANSFORM: {
                THE_ONLY_TRANSFER_OPPORTUNITY: 'Единственная возможность трансфера',
                CLICK: 'Кликните сюда!',
                DAY: 'День',
                MINUTE: 'Минуты',
                SECOND: 'Второй',
                HOURS: 'Часы',
                CRYPTO_REVELUTION: 'Криптовалютная революция на TopChange!',
                TRANSFER_TO_GC_P_ONE: 'переводить кошельки криптовалюты в TC',
                TRANSFER_TO_GC_P_TWO: 'на Специализированную платформу GreenChange',
                NEW_ENVIROMENT: 'GreenChange - новая среда для автоматического обмена валюты'
            }
        },
        BREAD_CRUMB: {
            'NOTIFICATION': 'Уведомления',
            'LOCAL_WITHDRAWALS_LIST': 'История заявок',
            'E_MONEY_WITHDRAWALS_LIST': 'История заявок электронных денег',
            'LOCAL_SEND_LIST': 'История заявок',
            'TC_WALLET_SEND_LIST': 'История платежей с Кошелька',
            'LOCAL_RECEIVE_LIST': 'История поступлений',
            'EXCHANGE_LOCAL_LIST': 'История обмена внутри системы',
            'ANOUNNCEMENT': 'Оповещения',
            'MONEY_CURRENCY': 'Методы оплаты',
            'DASHBOARD': 'Главная',
            'DEPOSIT': 'Пополнение',
            'WITHDRAWAL': 'Выводы',
            'SEND': 'Перевод',
            'BANK': 'Банк',
            'CASH': 'Наличные',
            'CREDIT': 'Кредит',
            'ONLINE': 'Оплата картой',
            'HISTORY': 'История заявок',
            'ELECTRONIC_MONEY': 'Электронные деньги',
            'NOTIFICATIONS': 'Уведомления',
            'FRIENDS': 'Друзья',
            'ACCOUNTS': 'Счета',
            'PROFILE': 'Профиль',
            'SUPPORT': 'Поддержка',
            'WALLETS': 'Кошельки',
            'WALLET_TC': 'Кошелёк ТС',
            'MY_WALLETS': 'Мои Кошельки',
            'EXCHANGE': 'Обмен',
            'POINT': 'Баллы',
            'ADD_WALLET': 'Создать Кошелёк',
            'EDIT_WALLET': 'Редактировать Кошелёк',
            'SETTING': 'Настройки',
            'FAQ': 'Часто задаваемые вопросы (FAQ)',
            'TICKETS': 'Обращения',
            'ADD_TICKET': 'Новое обращение',
            'CATEGORY': 'Группа',
            'MY_ACCOUNTS': 'Мои Счета',
            'ADD_BANK_ACCOUNT': 'Добавить новый счёт',
            'ADD_Service_ACCOUNT': 'Добавить новый счёт',
            'EDIT_ACCOUNT': 'Редактировать ',
            'TC_ACCOUNTS': 'Счета ТС',
            'ADD_SERVICE_ACCOUNT': 'Добавить новый счёт для Электронных денег',
            'TRANSACTIONS': 'Транзакции',
            'VOUCHER': 'Ваучер',
            'NEW': 'Новый',
            'DETAIL': 'Подробности',
            'MONEY_CURRENCY_LIST': 'История заявок',
            'ELECTRONIC_MONEY_LIST': 'История заявок',
            'REQUEST_DETAIL': 'Детали заявки',
            'NEW_REQUEST': 'Новая заявка',
            'TC_WALLET_LIST': 'История заявок ',
            'RECEIVE_TC_WALLET_LIST': 'История поступлений с Кошелька ТС',
            'RECEIVE_OTHER_WAYS_LIST': 'История поступлений ',
            'RECEIVE_DETAIL': 'Подробности поступления',
            'POINT_LIST': 'Список Баллов',
            'TRANSACTIONS_LIST': 'Список транзакций',
            'BUY': 'Покупка',
            'LIST': 'Список',
            'ADD_ACCOUNT': 'Добавить счёт',
            TRANSFER: 'Перевод',
            TRANSFER_INFO: 'Трансферное обучение',
        },
        QUICK_ACCESS: {
            DEPOSIT: 'Пополнение',
            DEPOSIT_NEW: 'Новое пополнение',
            DEPOSIT_LOCAL_PAYMENT_LIST: 'История заявок \'Локальная оплата\'',
            DEPOSIT_E_MONEY_LIST: 'История заявок \'Электронные деньги\'',
            WITHDRAWAL: 'Списание',
            WITHDRAWAL_NEW: 'Новое списание',
            WITHDRAWAL_LOCAL_PAYMENT_LIST: 'История выводов',
            WITHDRAWAL_E_MONEY_LIST: 'История выводов',
            SEND: 'Перевод',
            SEND_NEW: 'Новый перевод',
            SEND_TC_WALLET_LIST: 'История переводов',
            SEND_TC_WALLET: 'Перевод с кошелька',
            SEND_LOCAL_PAYMENT_LIST: 'История переводов',
            RECIEVE: 'Поступление',
            RECIEVE_TC_WALLET_LIST: 'История поступлений внутри системы',
            RECIEVE_LOCAL_LIST: 'История локальных поступлений',
            EXCHANGE: 'Обмен',
            EXCHANGE_NEW_LOCAL_PAYMENT: 'Новый локальный обмен',
            EXCHANGE_NEW_E_MONEY: 'Новый обмен электронных денег',
            EXCHANGE_LOCAL_PAYMENT_LIST: 'История операций \'локальный обмен\'',
            VOUCHER: 'Ваучер',
            VOUCHER_LIST: 'Список заявок',
            BUY: 'Покупка',
            LIST: 'Список',
            POINT: 'Баллы',
            WITHDRAWAL_POINT_LIST: 'История списаний баллов',
            WITHDRAWAL_POINT: 'Списание баллов',
            WITHDRAWAL_POINT_TRANSACTIONS: 'История баллов',
            WALLET_TRANSACTIONS: 'История кошелька',
            TRANSACTIONS: 'Транзакции',
            WALLET: 'Кошелёк',
            MY_WALLETS: 'Мои Кошельки',
            ACCOUNTS: 'Счета',
            MY_ACCOUNTS: 'Мои Счета',
            NEW_WALLET: 'Новый Кошелёк',
            NEW_E_MONEY_ACCOUNT: 'Новый счёт \'Электронные деньги\'',
            NEW_BANK_ACCOUNT: 'Новый банковский счёт',
            TC_ACCOUNTS: 'Счета ТС',
            FRIENDS: 'Друзья',
            MY_FRIENDS: 'Мои друзья',
            SUPPORT: 'Поддержка',
            TICKETS: 'Обращение',
            NEW_TICKET: 'Новое обращение',
            FAQ: 'Часто задаваемые вопросы (FAQ)',
            SETTING: 'Настройки',
            PROFILE: 'Профиль',
            NEW_LOCAL_PAYMENT: 'Новая заявка \'Локальная оплата\'',
            NEW_E_MONEY: 'Новая заявка \'Электронные деньги\'',
            NEW: 'Новая',
            LOCAL_PAYMENT_LIST: 'Список заявок \'Локальная оплата\'',
            E_MONEY_LIST: 'Список заявок \'Электронные деньги\'',
            EXCHANGE_NEW: 'Новый обмен',
            BUY_VOUCHER: 'Покупка Ваучера',
            CHANGE: 'Поменять',
            CHANGE_WITH: 'Поменять \'{{title}}\' на',
            ALERT: {
                SAVE_CHANGE_SUCCESSFULLY: 'Изменения успешно сохранены'
            }
        },
        ANNOUNCEMENT: {
            ARCHIVE: 'Архив',
            ACTIVE_ANNOUNCEMENTS: 'Активные оповещения',
            Alert: {
                NO_CONTENT: 'Содержимое не найдено'
            }
        },
        EVENT: {
            TITLE1: 'Криптовалютная революция в TopChange!',
            DESCRIPTION1: 'Перенести кошельки с криптовалютой на новую специализированную платформу под названием Green Change.',
            DESCRIPTION2: 'Новая среда для автоматического обмена криптовалютой',
            TITLE2: 'Green Change',
            BTN: 'Щелкните для получения дополнительной информации!',
            IMG: 'assets/media/images/events/PopUp-Transfer-en.png'
        },
        AUTH: {
            REQUIRED: 'Обязательный',
            NO_ACCOUNT: 'Нет Аккаунта?',
            FORGOT_PASSWORD: 'Забыли пароль?',
            TC_TERMS: 'Правила ТС',
            LOGOUT: 'Выйти',
            RESEND_CODE: 'Повторная отправка кода',
            WE_SENT_ACTIVATION_CODE_TO_PHONE: 'Код отправлен',
            ERROR_500: 'Ошибка. Пожалуйста, загрузите страницу заново.',
            ERROR_404: 'Заявка не найдена',
            INVALID_CAPTCHA: 'Капча недействительна',
            CONFIRM_MOBILE: 'Подтверждение номера мобильного телефона',
            CONFIRM_PERSONAL: 'Верификация Персональных данных',
            CONFIRM_PICTURE: 'Верификация Фотографии',
            CONFIRM_ADDRESS: 'Подтверждение адреса',
            ERROR_400: "Заявка недействительна",
            LOGIN: {
                TITLE: 'Вход',
                SUBMIT: 'Вход'
            },
            'RECOVER': {
                'TITLE': 'Восстановление пароля',
                'DESC1': 'Если Вы забыли свой пароль',
                'DESC2': 'Восстановите его по Email или SMS.',
                'PASS_NOT_SAME': 'Пароли не совпадают',
                'CONFIRM_PASS': 'Повторите пароль',
                'BY_EMAIL': {
                    'CODE_SENT': 'Код для подтверждения отправлен на Ваш Email.',
                    'HINT': 'Пожалуйста, введите код для подтверждения, отправленный на Ваш Email.'
                },
                'BY_SMS': {
                    'CODE_SENT': 'SMS с кодом для подтверждения отправлен на Ваш мобильный телефон.',
                    'HINT': 'Пожалуйста, введите код для подтверждения, отправленный на Ваш мобильный телефон.'
                },
                'EMAIL': 'Email',
                'SMS': 'SMS ',
                'SUCCESS': {
                    'TITLE': 'Пароль успешно изменён',
                    'DESC': 'Вы можете войти в свой Аккаунт прямо сейчас.',
                    'GO_TO_LOGIN': 'Вернуться на страницу входа'
                }
            },
            'REGISTER': {
                'TITLE': 'Регистрация',
                'LOGIN': 'Вход',
                'YOUR_EMAIL': 'Ваш Email',
                'SUBMIT_EMAIL': 'Регистрация',
                'SUBMIT_CONFIRM_EMAIL': 'Подтверждение',
                'SUBMIT_FORM': 'Создать Аккаунт',
                'CODE': 'Код для подтверждения',
                'ALREADY_HAVE_ACCOUNT': 'Уже есть Аккаунт?',
                'ENTER_EMAIL': 'Пожалуйста, введите свой Email',
                'SENT_EMAIL_TEXT': 'Вам отправлено письмо с {{value}} значным кодом.',
                'SENT_SMS_TEXT': 'Вам отправлено SMS с {{value}} значным кодом.',
                'PLEASE_COMPLETE_YOUR_FORM': 'Пожалуйста, заполните анкету полностью.',
                'DESC': 'Описание',
                'SUCCESS': {
                    'TITLE': 'Регистрация успешно выполнена',
                    'DESC': 'Вы можете войти в свой Аккаунт прямо сейчас.',
                    'GO_TO_LOGIN': 'Вход в Аккаунт'
                }
            },
            'INPUT': {
                'EMAIL': 'Email',
                'PHONE': 'Номер мобильного телефона',
                'FIRSTNAME': 'Имя',
                'LASTNAME': 'Фамилия',
                'COUNTRY': 'Страна',
                'I_ACCEPT': 'Принять',
                'TC_TERM': 'Правила ТС',
                'FULLNAME': 'Полное имя',
                'PASSWORD': 'Пароль ',
                'USERNAME': 'Логин',
                'NEW_PASSWORD': 'Новый пароль',
                'GENDER': 'Пол',
                'NEW_CONFIRM_PASS': 'Подтверждение нового пароля'
            },
            'VALIDATION': {
                'INVALID_EMAIL': 'Введённый адрес электронной почты недействителен'
            }
        },
        'SETTING': {
            'PAYMENT_GATEWAY': 'Платёжный терминал',
            'QUICK_ACCESS': 'Быстрый доступ',
            'TITLE': 'Настройки',
            'REQUEST_SECURITY_SETTING': 'Безопасность заявок',
            'DEFAULT_LANGUAGE': 'Язык по умолчанию',
            'TIME_ZONE': 'Часовой пояс',
            'LOCAL': 'Местное ',
            'GENERAL_TEXT': 'Общие',
            'SETTING_GENERAL': 'Общие',
            'REQUEST_SECURITY': 'Безопасность заявок',
            'SETTING_REQUEST_SECURITY': 'Безопасность заявок',
            'NOTIFY_SYSTEM': 'Оповещения системы',
            'NOTIFY_SYSTEM_SETTING': 'Оповещения системы',
            'WALLET_CHANGE': 'Изменение в Кошельке',
            'POINT_CHANGE': 'Изменение в разделе \'Баллы\'',
            'SMS_CREDIT_CHANGE': 'Изменение кредита панели SMS',
            'EMAIL': 'Email',
            'SMS': 'SMS',
            'DASHBOARD': 'Главная',
            'FRIEND': 'Друзья',
            'POINT': 'Списание баллов',
            'INTERNAL_TRANSFER': 'Внутренний перевод',
            'SERVICE': 'Электронные деньги',
            'EXCHANGE': 'Обмен',
            'VOUCHER': 'Ваучер',
            'POINT_WITHDRAWAL': 'Списание баллов',
            'LOGIN': 'Вход',
            'REQUEST_PAYMENT': 'Платежи',
            'SEND': 'Перевод',
            'RECEIVE': 'Получение',
            'REQUEST_MESSAGE': 'Сообщение в заявке ',
            'VERIFY_BANK_ACCOUNT': 'Подтверждение банковского счёта',
            'SECURITY_SETTING': 'Настройки безопасности',
            'TICKET': 'Обращение',
            'VERIFY_INFORMATION': 'Подтверждение персональных данных',
            'PAYMENTS': 'Платежи',
            'VERIFY_INFO': 'Подтверждение данных',
            'FRIENDS': 'Друзья',
            'MESSAGE': 'Сообщения',
            'MY_CHANGES': 'Мои изменения',
            'AUTO_CHANGES': 'Системные изменения',
            'DISABLED': 'Деактивировать',
            'BETWEEN_MY_WALLETS': 'Перевод между моими Кошельками',
            'SEND_CONFIRMATION_CODE': 'Отправить код подтверждения',
            'POSSIBLE_TO_HAVE_SECURITY_CODE': 'Для сохранения изменений введите код, отправленный на Ваш Email.',
            'REQUESTS': 'Заявки',
            'VERIFIED': 'Верификация',
            'EXPERT_MESSAGES': 'Сообщения от Эксперта',
            EXPERT_OR_FRIENDS_CHANGES: "Изменения друзей или Эксперта",
            DISPLAY_LANGUAGE: "ЯЗЫК ДИСПЛЕЯ",
            DISPLAY_LANGUAGE_DESCRIPTION: "Веб-сайт будет отображаться на выбранном языке",
            NOTIFICATION_LANGUAGE: "Язык уведомлений",
            NOTIFICATION_LANGUAGE_DESCRIPTION: "Уведомление появится на выбранном языке.",
            TIME_ZONE_DESCRIPTION: "Часовой пояс будет отображаться на выбранном языке.",
            'ALERT': {
                'CHANGES_SAVED_SUCCESSFULLY': 'Изменения успешно сохранены'
            }
        },
        'FRIENDS': {
            'FRIEND': 'Друг',
            'MY_FRIENDS': 'Мои друзья',
            'FRIENDS_REQUEST': 'Заявки на дружбу',
            'SENT_REQUEST': 'Отправленные заявки ',
            'BLOCKED_USER': 'Заблокированные пользователи',
            'ACCEPT': 'Принять',
            'REJECT': 'Отклонить',
            'UNBLOCK': 'Разблокировать',
            'MORE': 'Больше',
            'UNFRIEND': 'Удалить из друзей',
            'BLOCK': 'Заблокировать',
            'DEPOSIT': 'Пополнение счёта',
            'WALLETS': 'Кошельки',
            'SEND_FRIEND_REQUEST': 'Отправить Заявку на дружбу',
            'SEND_REQUEST': 'Отправить Заявку',
            'ADD_FRIEND': 'Добавить друга',
            'SEND': 'Отправить',
            'ALERT': {
                'SUCCECC_REJECT': 'Заявка на дружбу отклонена',
                'SUCCECC_ACCEPT': 'Заявка на дружбу принята',
                'SUCCECC_DELETE': 'Заявка на дружбу удалена',
                'SUCCECC_DELETE_FIREND': 'Выбранный пользователь удалён из Ваших друзей',
                'SUCCECC_BLOCK': 'Выбранный пользователь заблокирован',
                'REQUEST_SENT_SUCCESSFULLY': 'Заявка на дружбу успешно отправлена',
                'CONFIRM_DELETE_REQUEST': 'Вы уверены,что хотите удалить эту заявку?',
                'CONFIRM_REJECT_REQUEST': 'Вы уверены,что хотите отклонить эту заявку?',
                'REQUEST_SENT_USER_NOT_FOUND': 'Данный пользователь не найден. Ваше приглашение отправлено ему по Email.'
            },
            'ALERT_DELETE': 'Вы уверены,что хотите удалить этого пользователя из друзей?',
            'SEND_FRIEND_REQUEST_HINT': 'Для отправки заявки на дружбу введите Email пользователя. Если пользователь существует, ему будет отправлена заявка на дружбу.'
        },
        ACCOUNTS: {
            'CARD_NUMBER': 'Номер карты',
            'ACCOUNT_NUMBER': 'Номер счета',
            'IBAN_NUMBER': 'Международный номер банковского счёта',
            'SERVICE': 'Электронные деньги',
            'SERVICES': 'Электронные деньги',
            'BANKS': 'Банки',
            'BANK': 'Банк ',
            'ACCOUNTS_INFORMATION': 'Данные счёта',
            'ACCOUNTS': 'Счета',
            'ACCOUNT': 'Счёт',
            'ACCOUNT_NO': 'Номер счёта',
            'CARD_NO': 'Номер карты',
            'TC_BANK_ACCOUNT': 'Банковский счёт ТС',
            'NEW_SERVICE': 'Новый счёт \'Электронные деньги\'',
            'NEW_BANKS': 'Новый банковский счёт',
            'BRANCH_CODE': 'Код подразделения банка',
            'BANK_NAME': 'Название банка',
            'SWIFT_CODE': 'СВИФТ Код',
            'OWNER': 'Владелец счёта',
            'BANK_ADDRESS': 'Адрес банка',
            'EDIT_BANK_ACCOUNT': 'Редактировать данные банковского счёта',
            'ADD_BANK_ACCOUNT': 'Новый банковский счёт',
            'MY_ACCOUNT': 'Мой счёт',
            'TC_ACCOUNT': 'Счёт ТС',
            'NEW_SERVICE_ACCOUNT': 'Новый счёт \'Электронные деньги\'',
            'EDIT_SERVICE_ACCOUNT': 'Редактировать данные счёта \'Электронные деньги\'',
            'ACCOUNT_OWNERS_NAME': 'Имя владельца счёта',
            BANK_ACCOUNT_LIST: '‌‌Банковские счета',
            EMONEY_ACCOUNT_LIST: 'Электронные деньги',
            CRYPTO_ACCOUNT_LIST: 'Криптовалютные счета',
            CRYPTO: "Криптовалюта",
            EDIT_CRYPTO_ACCOUNT: "Редактировать данные  криптовалютного счёта",
            NEW_CRYPTO: "Новый криптовалютный счёт ",
            ALERT: {
                ADD_SUCCESS: 'Счёт успешно создан',
                EDIT_SUCCESS: 'Редактирование счёта успешно выполнено',
                DELETE_SERVICE: 'Вы уверены, что хотите удалить счёт \'Электронные деньги\'?',
                DELETE_BANK: 'Вы уверены, что хотите удалить банковский счёт?',
                DELETE_SUCCESS: 'Выбранный счёт успешно удалён',
                YOUR_SERVICE_ACCOUNT_IS_EMPTY: 'Счёт \'Электронные деньги\' зарегистрирован',
                ADD_BANK_ACCOUNT: 'Добавить банковский счёт',
                ADD_SERVICE_ACCOUNT: 'Добавить счёт \'Электронные деньги\'',
                VERIFY_TIME_INFO: 'Счёт будет автоматически верифицирован после успешного выполнения первой заявки.',
                ACCOUNT_INFO_COPIED: 'Сведения счёта скопированы в буфер обмена',
                VERIFY_NEEDS: 'Ваши персональные данные не верифицированы',
                BANK_ACCOUNT_IS_PENDING: 'Сведения Вашего счёта будут рассмотрены нашими операторами',
                ADD_CRYPTO_ACCOUNT: "Добавить криптовалютный счёт ",
                YOUR_CRYPTO_ACCOUNT_IS_EMPTY: "Криптовалютный счёт не зарегистрирован",
                FOR_ADD_BANK_ACCOUNT: 'Добавить банковский счёт',
                YOUR_BANK_ACCOUNT_IS_EMPTY: 'Укажите банковские реквизиты',
            }
        },
        'TICKETS': {
            'ATTACHMENT': 'Прикрепить файл',
            'I_HAVE_TRACKING_NUMBER': 'У меня есть номер заявки',
            'NEW_TICKET': 'Новое обращение',
            'TICKET_NUMBER': 'Номер обращения',
            'DEPARTMENT': 'Отдел',
            'TICKET_STATE': 'Статус',
            'SUBJECT': 'Тема',
            'PRIORITY': 'Приоритет',
            'TEXT': 'Текст',
            'TICKET_NO': 'Номер обращения',
            'LOCK_MESSAGE': 'Ваш Кошелёк заблокирован, для получения информации обращайтесь в поддержку',
            'MESSAGE': 'Сообщение',
            ALERT: {
                ADD_SUCCESS: 'Ваше обращение успешно зарегистрировано в системе.',
                TICKET_REPLY_SUCCESS: 'Ваше сообщение успешно отправлено.',
                CLOSE_SUCCESS: 'Обращение успешно закрыто.',
                NOT_FOUND: 'Указанное обращение не найдено.',
                CLOSE_CONFIRM: 'Вы уверены, что хотите закрыть обращение?',
                CLOSED_BEFORE: 'Вы уже закрыли это обращение',
                ADD_RATE_SUCCESS: 'Ваша оценка успешно оценена',
                SEND_MESSAGE_TO_OPEN_TICKETS: 'Для повторного открытия обращения отправьте ответ на него.',
                TICKET_HAS_BEEN_ARCHIVED: 'тот билет был заархивирован, и на него невозможно ответить',
            }
        },
        'FAQ': {
            'HOW_CAN_HELP': 'Добро пожаловать. Как я могу Вам помочь?',
            'ASK_QUESTION': 'Задать вопрос',
            'BROWSE_TOPICS': 'Основные темы',
            'FREQUENTLY_QUESTIONS': 'Часто задаваемые вопросы (FAQ)'
        },
        'HISTORY': {
            'SERVICE': 'Электронные деньги',
            'WALLET': 'Кошелёк',
            'REQUEST_STATUS': 'Статус Заявки'
        },
        PROFILE: {
            'TITLE': 'Профиль',
            'CONTACT_INFO': "Контактная информация",
            'ADDRESS': 'Адрес',
            'ADDRESS_INFO': 'Адрес',
            'ADDRESSES_DOC': 'Выбрать изображение ',
            'BIRTH_DATE': 'Дата Рождения',
            'COUNTRY': 'Страна',
            'CITY': 'Город',
            'STATE': 'Район',
            'LANDLINE_NUMBER': 'Номер стационарного телефона',
            'ZIP_CODE': 'Почтовый индекс',
            'VERIFICATION': 'Верификация данных',
            'ENTER_CODE': 'Введите код',
            'CHANGE_PASSWORD': 'Изменение пароля',
            'ACCOUNT_INFO': 'Информация о счёте',
            'OLD_PASSWORD': 'Старый пароль',
            'NEW_PASSWORD': 'Новый пароль',
            'CONFIRM_NEW_PASSWORD': 'Подтверждение нового пароля',
            'PERSONAL_INFO': 'Персональные данные',
            'NOT_VERIFIED': 'Не верифицированы',
            'NOT_VERIFIED2': 'Не верифицировано',
            'NOT_VERIFIED3': 'Не верифицирован',
            'IDENTITY_CARD': 'Удостоверения личности',
            'VERIFIED': 'Верифицирован',
            'VERIFIED2': 'Верифицированы',
            'VERIFY_NOW': 'Верифицировать сейчас',
            'VERIFY_PERSONAL_INFO': 'Подтверждение персональных данных',
            'PHOTO': 'Фото',
            'IMAGE_DETAIL': 'Подробности',
            'VERIFY_TEXT': 'Подтвердить',
            'DRIVING_LICENSE': 'Водительское удостоверение',
            'PASSPORT': 'Паспорт',
            'PHONE_NUMBER': 'Номер мобильного телефона',
            'FRONT_OF_ID_CARD': 'Фронтальная сторона ID Карты',
            'BACK_OF_ID_CARD': 'Оборотная сторона ID Карты',
            'FRONT_IMAGE': 'Фронтальная сторона ID Карты',
            'BACK_IMAGE': 'Оборотная сторона ID Карты',
            'TAKE_IMAGE': 'Сделать фото',
            'IF_IMAGE_NOT_GOOD': 'Если качество изображения неудовлетворительно',
            'TAKE_NEW_ONE': 'Сделайте новое фото',
            'REG_DATE': 'Дата регистрации',
            'UPLOAD_IMAGE': 'Выбрать изображение',
            'UPLOAD_DRIVING_PHOTO': 'Выбрать изображение ВУ',
            'UPLOAD_PASSPORT_PHOTO': 'Выбрать изображение Паспорта',
            'UPLOAD_IDENTITY_CARD_PHOTO': 'Загрузить изображение ID Карты',
            'UPLOAD_PHOTO_OF_PASSPORT': 'Загрузить изображение Паспорта',
            'UPLOAD_IMAGE_FROM_YOUR_STORAGE': 'Загрузить изображение из хранилища',
            'USE_CAMERA_TO_TAKE_IMAGE': 'Воспользуйтесь камерой своего телефона, чтобы сделать фото.',
            'USER_GROUP': 'Пользовательская группа',
            'MOBILE_NUMBER': 'Номер мобильного телефона',
            'WRITE_BLOW_CODE_ON_PAPER': 'Напишите этот код на листе бумаги',
            'YOUR_PHONE_NUMBER': 'Номер мобильного телефона',
            'EDIT_MOBILE_INFO': 'Чтобы изменить номер мобильного телефона, сначала верифицируйте свой текущий номер.',
            'VERIFY_CURRENT_PHONE_NUMBER': 'Подтверждение текущего номера мобильного телефона',
            'SELECT_ONE_BELOW_OPTIONS': 'Пожалуйста, выберите одну из нижеперечисленных опций',
            'ENTER_YOUR_PHONE_NUMBER': 'Введите свой номер мобильного телефона',
            'CHANGE_YOUR_PHONE_NUMBER_QUESTION': 'Хотите поменять свой номер мобильного телефона',
            'PLEASE_VERFY_PROFILE': 'Чтобы Вы могли воспользоваться услугами, вначале Вам необходимо верифицировать свои персональные данные.',
            'VERIFY_DESCRIPTION': 'Уважаемый пользователь, для повышения вашей безопасности и предотвращения нарушений со стороны спекулянтов, пожалуйста, подтвердите следующую информацию',
            'FIRST_NAME': 'имя',
            'LAST_NAME': 'Фамилия',
            'BIRTHDAY': 'день рождения',
            'BIRTHDATE': 'день рождения',
            'GENDER': 'Пол',
            'YOUR_MOBILE_NUMBER_IS': 'Ваш номер мобильного телефона',
            CHANGE_AVATAR: 'Сменить аватар',
            SELECT_AVATAR_MESSAGE: 'Пожалуйста, выберите свою фотографию пользователя и нажмите "Отправить"',
            SELECT_AVATAR: 'Выберите аватар',
            'VERIFY': {
                'VERIFY': 'Проверять',
                'TYPE': {
                    'ADDRESS': 'Сведения об адресе проживания',
                    'PERSONAL': 'Персональные данные',
                    'PERSONAL_IDENTITY': 'Персональные данные',
                    'PERSONAL_PASSPORT': 'Персональные данные',
                    'DRIVER_LICENSE': 'Персональные данные',
                    'UPLOAD_FRONT_OF_YOUR_IDENTITY_CARD_IMAGE': 'Загрузите переднюю часть изображения вашего удостоверения личности',
                    'UPLOAD_BACK_OF_YOUR_IDENTITY_CARD_IMAGE': 'Загрузите изображение вашего удостоверения личности на оборотной стороне',
                    'PHOTO_UPLOAD': 'Фото',
                    'PHOTO_CAMERA': 'Фото'
                },
                'NOTIFY': {
                    'TITLE': {
                        'VERIFY_INFO': 'Верификация данных'
                    },
                    'NOTIFICATION': {
                        'BODY': {
                            'ACCEPTED': '{{0}} верифицированы',
                            'REJECTED': '{{0}} отклонены'
                        }
                    }
                },
            },
            ERROR: {
                'PASSWORD_IS_NOT_SAME': 'Пароли не совпадают'
            },
            TAKE_PIC_DESCRIPTION: 'Уважаемый Пользователь, во избежание различного вида нарушений и сохранения безопасности операций отправьте нам своё фото со следующими сведениями. <br/> Все сведения должны быть написаны синей ручкой на белом листе бумаги. <br/> 1- размер файла должен быть менее 2Мгб. <br/> 2- Расположите лист бумаги с необходимыми сведениями перед собой. <br/> 3- Приложите к листу свой документ, удостоверяющий личность, как показано на картинке. <br/> 4- Напишите своей рукой на листе код, показанный ниже. <br/> 5- Напишите своей рукой на листе следующий текст: \' Я, .... .... (номер документа удостоверяющего личность ....) отправил свои данные сайту Top Change дата\'. <br/> 6- Ваша подпись.',
            ALERT: {
                'PASSWORD_CHANGED_SUCCESSFULLY': 'Пароль успешно изменён! Пожалуйста, выполните вход заново. ',
                'MOBILE_NUMBER_HAS_BEEN_VERIFIED': 'Номер мобильного телефона успешно подтверждён.',
                'PEERSONAL_INFO_HAS_BEEN_UPDATED': 'Ваши персональные данные успешно обновлены.',
                'ADDRESS_HAS_BEEN_UPDATED': 'Сведения об адресе проживания успешно обновлены.',
                'ERROR_PERSONAL_INFO_NOT_VERIFIED': 'Ваши персональные данные не верифицированы.',
                'ERROR_PERSONAL_INFO_REJECTED': 'Ваша заявка на подтверждение персональных данных отклонена.',
                'ERROR_PHOTO_VERIFY_REJECTED': 'Ваша заявка на подтверждение данных отклонена.',
                'PERSONAL_INFO_SHOULD_MATCH_WITH_ID_CARD': 'Внимание: Введённые персональные данные должны совпадать с информацией, указанной в документе, удостоверяющем личность.',
                'PERSONAL_INFO_VERIFY_IS_PENDING': 'Ваши сведения находятся в процессе рассмотрения нашими операторами.',
                'ADDRESS_VERIFY_IS_PENDING': 'Сведения о Вашем адресе проживания находятся в процессе рассмотрения нашими операторами.',
                'PHOTO_VERIFY_IS_PENDING': 'Ваши сведения находятся в процессе рассмотрения нашими операторами.',
                'PERSONAL_INFO_VERIFYED': 'Ваши персональные данные успешно верифицированы.',
                'PHOTO_VERIFY_ACCEPTED': 'Ваши данные успешно верифицированы.',
                'ADDRESS_VERIFYED': 'Сведения о Вашем адресе проживания успешно верифицированы.',
                'DOCUMENTS_UPLOADED': 'Загрузка документов успешно выполнена.',
                'ERROR_ADDRESS_INFO_REJECTED': 'Ваша заявка на подтверждение адреса проживания отклонена.',
                'ADDRESS_UPLOAD_HINT': 'Внимание: Для подтверждения адреса отправьте разборчивое фото одного из нижеперечисленных документов: квитанция на оплату услуг ЖКХ за текущий год, документ на собственность, Договор Аренды. Введённый адрес должен полностью совпадать с информацией, указанной в документе.',
                'ERROR_ADDRESS_INFO_NOT_VERIFIED': 'Сведения о Вашем адресе проживания не подтверждены.',
                'VERIFY_NEEDS': 'Ваши персональные данные не подтверждены.',
                'NEED_FILL_PERSONAL_FORM': 'Чтобы активировать верификационную часть, пожалуйста, вначале заполните личные данные.',
                'NEED_FILL_ADDRESS_FORM': 'Подтверждение об адресе проживания не обязательно. В случае если Вы захотите воспользоваться услугами сайта в полном объёме, Вы также можете верифицировать свой адрес.',
                'ADDRESS_IS_OPTIONAL': 'Чтобы активировать верификационную часть, пожалуйста, вначале заполните бланк сведений о Вашем адресе проживания.',
                'PASSWORD_MIN_LENGTH': 'Пароль должен содержать минимум {{value}} знаков.',
                'PASSWORD_MAX_LENGTH': 'Пароль может содержать максимум {{value}} знаков.'
            }
        },
        'NOTIFICATION': {
            'TITLE': 'Уведомление',
            'NOTIFICATIONS': 'Уведомления',
            'DESCRIPTION': 'Описание',
            'EMPTY': 'Уведомлений нет',
            'FRIENDS': 'Друзья',
            'TICKETS': 'Обращение',
            'ADMIN': 'Админ',
            'NEW': 'Новое',
            'ME': 'Я',
            'TYPE': 'Вид уведомления',
            'EMPTY_TICKETS': 'Пусто',
            'EMPTY_FRIENDS': 'Новых заявок нет'
        },
        TRANSFER: {
            TRANSFER_FROM_TC_TO_GC: 'Transfer from Topchange wallet to Greenchange website',
            TOPCHANGE_LOOKING_FOR_SAFETY: '',
            TRANSFER_ANNOUNCEMENT: {
                TITLE: 'Перенести криптовалюту Topchange на сайт Greenchange',
                DESCRIPTION: 'Пользователи, которые ранее работали на сайте topchange в области пароля валюты, эта группа пользователей с тем же адресом электронной почты и паролем учетной записи TopChange сможет войти на сайт GreenChange и не будет нуждаться в регистрации и аутентификации на Green Change сайт. Они по-прежнему могут продолжать работать с фиатными кошельками в Top Change, но после передачи кошельков криптовалюты в GC они должны обменять свои криптовалюты на веб-сайте Green Change.',
                ITEM1: 'Автоматически вносить и снимать коды валют',
                ITEM2: 'Повышение безопасности транзакций',
                ITEM3: 'Добавьте больше услуг в области криптографии валюты'
            },
            NEW_CHANGES: {
                TITLE: 'Новые изменения криптовалют на сайте Topchange',
                BUY: {
                    TITLE: 'Купить код валюты',
                    PRE_DESCRIPTION: 'Пополнение кошельков Green Change паролей через инвентарь фиатных кошельков на Topchange',
                    DESCRIPTION: 'Вы можете пополнить свои криптовалютные кошельки в Green Change через фиатные кошельки в TC.'
                },
                SELL: {
                    TITLE: 'Продать код валюты',
                    PRE_DESCRIPTION: 'Выводите из кошельков Green Change password и переводите деньги на свои фиатные кошельки в TC',
                    DESCRIPTION: 'Вы можете внести свои коды валют из кошелька Greenchange на свои фиатные кошельки в TC и получить желаемую сумму наличными, в банке и т. Д. С помощью методов вывода в TC.'
                }
            },
            TRANSFER_LERANING: {
                TITLE: 'Что я могу сделать, чтобы перевести кошельки с валютой TC в GC?',
                QUESTION_ONE_LOGIN_TITLE: 'У меня была транзакция, связанная с кошельками криптовалюты в TC',
                QUESTION_ONE_LOGIN_DESCRIPTION: 'Эта группа пользователей с тем же адресом электронной почты и паролем, что и их учетная запись TopChange, сможет войти на сайт GreenChange, и им не потребуется регистрироваться и проходить аутентификацию на сайте Green Change. <br/> может продолжать работать с фиатными кошельками. в Top Change, но после передачи кошельков криптовалюты в GC они должны произвести свои собственные обмены в отношении криптовалюты на веб-сайте Green Change.',
                QUESTION_ONE_LOGIN_BTN: 'Войти в GC',
                QUESTION_ONE_REGISTER_TITLE: 'Я еще не зарегистрировал заявку в валютных кошельках TC!',
                QUESTION_ONE_REGISTER_DESCRIPTION: 'Эта группа пользователей также может продолжить свою деятельность с фиатными кошельками в Top Change. Но если они заинтересованы в использовании услуг обмена валюты, они должны зарегистрироваться и пройти аутентификацию на сайте Green Change.',
                QUESTION_ONE_REGISTER_BTN: 'Зарегистрируйтесь на GC',
                TRANSFER_DEADLINE: 'Крайний срок перевода: 8 июля.',
                QUESTION_TWO_REGISTER_DESCRIPTION: 'В течение этого периода у вас есть возможность перевести свои криптовалюты из <span class="tc-span">TopChange</span> в <span class="gc-span">GreenChange</span> или вывести свои остатки криптовалюты, в противном случае перевод ваших криптовалют будет выполнен автоматически 9 июля. Возьми'
            },
            TRANSFER_REPORT: {
                TITLE: 'Перенести кошельки TopChange на сайт Green Change',
                DESCRIPTION: 'lorem ipsun',
                WALLET: 'кошелек',
                PRICE: 'Количество',
                BOX_INFO: {
                    TITLE: 'характеристики',
                    TEXT: 'Dear user, there is a user with your profile on the GreenChange site, if this account belongs to you, proceed to continue the transfer, otherwise contact us from the <a href="/support/tickets">ticket</a> section.',
                    FULL_NAME: 'ФИО',
                    USERNAME: 'Имя пользователя',
                    DATE_OF_BIRTH: 'Дата рождения',
                    NATIONAL_CODE: 'Национальный номер',
                    PASSPORT: 'Заграничный пасспорт'
                },
                CHECK_INFO_TXT: 'Технические характеристики, представленные на сайте GreenChange, принадлежат мне.',
                CHECK_POLICY_TXT: 'я согласен что :<br/><ul><li>для меня будет открыта новая учетная запись пользователя в Green Change (http://greenchange.io).</li><li>для доступа к моей учетной записи с помощью Green Change мне нужно использовать то же имя пользователя и пароль, что и для Top Change</li><li>все мои криптоактивы будут переведены из Top Change в Green Change.</li></ul>',
                TRANSFER_BTN: 'перевод',
                ALERT_AFTER_TRANSFER: 'Уважаемый пользователь, ваш перевод осуществлен.'
            },
            CONFIRM_DIALOG: {
                TITLE: 'Подтверждение перевода',
                ENTER_CODE: 'Чтобы отправить запрос, введите код подтверждения, отправленный на адреса <span> {{phoneNumber}} </span> и <span> {{userEmail}} </span>.',
                CANCEL: 'Отмена'
            },
            LEARN_FILES: {
                TITLE: 'Образовательные файлы',
                FILE_NAME1: 'Как перевести деньги с Greenchange на TC',
                FILE_NAME2: 'Аутентификация',
                FILE_NAME3: 'Как перевести деньги с ТC на Greenchange',
            },
            ALERT: {
                TRANSFER_DONE_SUCCESSFULLY: 'Операция передачи прошла успешно.',
                TRANSFER_DONE: 'Уважаемый пользователь, Ваши кошельки с криптовалютой успешно переведены из TopChange в GreenChange.',
                TRANSFER_DONE1: 'Dear user, your transfer has been done!',
                TRANSFER_DONE2: 'You can login to Greenchange and view your Cryptocurrency wallets.',
                TRANSFER_DONE3: 'Login to Greenchange',
                WITHOUT_TRANSACTION: 'Уважаемый пользователь, в ваших кошельках с криптовалютой нет транзакций.'
            }
        },
        GENERAL: {
            TITLE: 'Заголовок',
            SHOW_ALL: 'Показать все',
            DASHBOARD: 'Главная',
            TRANSACTIONS: 'Транзакции',
            EXCHANGE: 'Обмен',
            CHANGE: "Изменять",
            WITHDRAW: 'Списание',
            RECIEVE: 'Получение',
            DEPOSIT: 'Пополнение',
            DOWNLOAD: 'Скачать',
            CONTINUE_CONFIRM: 'Продолжить',
            AUTH_ALERT_TEXT: 'Уважаемый Пользователь, для {{value}} необходима верификация следующих данных:',
            AUTHENTICATION: 'Аутентификация',
            SUMMARY: 'Сведения платежа',
            ADD: 'Добавить',
            DONE: 'Подтверждён',
            REFUND: 'Возврат суммы',
            ACTION: 'Действия',
            ALERT: 'Предупреждение',
            ALL: 'Все',
            CHOOSE: "Выбор",
            CRYPTO: "Криптовалюта",
            EMONEY: "Электронные денежные средства",
            EXAMPLE: 'Пример',
            ACTIONS: 'Действия',
            ATTACHMENT: 'Файлы',
            ATTACHMENT_VIEW: 'Прикреплённый файл',
            ALLOWED_FILES: 'Допустимые форматы',
            BACK: 'Вернуться',
            BLOCK: 'Заблокировать',
            CLICK_HERE: 'Кликните здесь',
            CONFIRM: 'Подтвердить',
            CODE: 'Код',
            CANCEL: 'Отмена',
            CATEGORY: 'Группа',
            DELETE: 'Удалить',
            SECOND_AGO: 'Секунду назад',
            MINUTES_AGO: 'Минуту назад',
            HOURS_AGO: 'Час назад',
            DESCRIPTION: 'Описание',
            DATE: 'Дата',
            STATUS_DATE: 'Дата изменения статуса',
            DATE_FROM: 'С',
            DATE_TO: 'По',
            CHANGE_FILE: 'Изменить файл',
            EXPORT: 'Экспортировать',
            ERROR: 'Ошибка',
            EMAIL: 'E-mail',
            HELP: 'Помощь',
            LAST_UPDATE: 'Последнее обновление',
            CLICK_TO_COPY_NUMBER: 'Чтобы скопировать, нажмите на номер',
            SAVE: 'Сохранить',
            YES: 'Да',
            NO: 'Нет',
            CREATE: 'Создать ',
            ACTIVE: 'Активный',
            NEW: 'Новый ',
            EDIT: 'Редактировать ',
            WATING: 'Ожидание',
            FILTER: 'Фильтр',
            CLEARE_ALL: 'Очистить',
            MESSAGE: 'Сообщение ',
            MORE_INFO: 'Дополнительная информация',
            NEXT: 'Далее',
            POINT: 'Баллы',
            SEARCH: 'Поиск',
            REPLAY: 'Ответ',
            ROW: 'Строка ',
            TYPE: 'Вид',
            CLOSE: 'Закрыть',
            SUBJECT: 'Тема',
            SUBMIT: 'Зарегистрировать',
            EXIT: 'Выход',
            DETAILS: 'Подробности',
            SEND: 'Отправка ',
            REJECTED: 'Отклонена',
            WAITING: 'Ожидание',
            CONGRATULATION: 'Поздравляем',
            UPLOADING: 'Загрузка ',
            CONFIRM_AND_UPLOAD: 'Подтвердить и загрузить',
            PHONE: 'Мобильный телефон',
            SERVICE: 'Электронные деньги',
            SEND_CODE: 'Отправить код',
            SECURITY_CODE: 'Код подтверждения',
            STATUS_TEXT: 'Статус ',
            SELECT_FILE: 'Выбрать файл',
            EXPERT_COMMENT: 'Пояснения эксперта',
            SELL: 'Продажа',
            BUY: 'Покупка ',
            REQUEST: 'Заявка ',
            QUICK_ACCESS: 'Быстрый доступ',
            TEXT: 'Текст',
            NAME: 'Имя',
            MALE: 'Мужской',
            FEMALE: 'Женский',
            UPDATE: 'Обновление',
            TRACKING_NUMBER: 'Номер отслеживания',
            NEW_STATUS: 'Новый статус',
            SMS_CREDIT: 'Баланс для СМС',
            RETURN: 'Вернуться',
            ALERT_DELETE: 'Вы уверены, что хотите удалить {{value}}?',
            ALERT_SECURE_CODE_TIME_EXPIRED: 'Срок кода подтверждения истёк',
            NO_ITEM_TOـSHOW: 'Не найдено',
            HOME: 'На главную',
            DEACTIVE: 'Деактивирован',
            NOTHING_TO_DISPLAY: 'Не найдено',
            SELECT: 'Выбирать',

            FILE_UPLOAD_LIMITAION: {
                SIZE: 'Максимальный размер файла: {{value}} Мб',
                FORMAT: 'Поддерживаемые форматы файлов: {{value}}'
            },
            INPUT: {
                CHOOSE_CURRENCY: 'Валюта',
                MORE_INFO: 'Дополнительная информация'
            },
            STATUS: {
                PENDING: 'В процессе рассмотрения',
                WAITING: 'Ожидание'
            },
            DISABLED: 'Деактивировать',
        },
        'ENUM': {
            'WALLET_TYPES': {
                'SAVING_ACCOUNT': 'Сберегательный счёт',
                'TRANSIT_ACCOUNT': 'Транзитный счёт'
            },
            'ARCHIVE': {
                'ARCHIVED': 'Архивировано',
                'NONE_ARCHIVED': 'Не архивировано'
            },
            'WALLET_CHANGE_TYPE': {
                'OUTGOING_PAYMENTS': 'Списание',
                'INCOMING_PAYMENTS': 'Пополнение'
            },
            'CHANGE_TYPE': {
                'DECREASE': 'Увеличение',
                'INCREASE': 'Сокращение'
            },
            'SEEN_USER_TYPES': {
                'NOBODY': 'Никто',
                'FRIENDS': 'Друзья',
                'EVERYONE': 'Все'
            },
            'PRIORITY_TYPES': {
                'HIGH': 'Высокий',
                'MEDIUM': 'Средний',
                'LOW': 'Низкий'
            },
            TICKET_STATUS: {
                OPEN: 'Открытый',
                ANSWERD: 'Отвечен',
                CUSTOMER_REPLY: 'Мой ответ',
                ON_HOLD: 'Ожидание',
                IN_PROGRESS: 'В процессе рассмотрения',
                CLOSED: 'Закрыт ',
                TC_CONTACT: 'Сообщение ТС',
                ARCHIVED: 'Архивировано'
            },
            'PAYMENT_TYPE': {
                'BANK': 'Банк ',
                'CASH': 'Наличными',
                'CREDIT': 'Кредит',
                'ONLINE': 'Онлайн',
                'ELECTRONIC_MONEY': 'Электронные деньги'
            },
            'SEND_PAYMENT_TYPE': {
                'BANK': 'Из банка на Кошелёк ТС',
                'CASH': 'Наличными на Кошелёк ТС',
                'CREDIT': 'Кредит на Кошелёк ТС',
                'ONLINE': 'Онлайн на Кошелёк ТС',
                'ELECTRONIC_MONEY': 'Электронные деньги на Кошелёк ТС'
            },
            'PAYMENT_STATUS': {
                'NO_CONFIRMED': 'Не подтверждён',
                'PENDING': 'В процессе рассмотрения',
                'ACCEPTED': 'Подтверждён',
                'REJECTED': 'Отклонён'
            },
            'ACCOUNT_STATUS': {
                'UNVERIFIED': 'Неверифицирован',
                'VERIFIED': 'Верифицирован',
                'PENDING': 'Ожидает рассмотрения',
                'ACCEPTED': 'Подтверждён',
                'REJECTED': 'Отклонён',
                'BLOCKED': 'Заблокирован'
            },
            'REQUEST_STATUS': {
                'NEW': 'Новая',
                'PROCESSING': 'В процессе рассмотрения',
                'PENDING': 'Ожидает рассмотрения',
                'ACCEPTED': 'Принята',
                'REJECTED': 'Отклонена',
                'PAYMENT': 'Оплата',
                'DONE': 'Выполнена',
                'DELETED': 'Удалён',
                'FAILED': 'Платеж не прошел',
                'REFUND': 'Возврат суммы',
                Paying: "Оплата"
            },
            'ONLINE_PAYMENT_STATUS': {
                'INCOMPLETE': 'Не завершён',
                'FAILED': 'Платеж не прошел',
                'SUCCESS': 'Успешный',
                'REFUND': 'Возврат суммы'
            },
            'POINT_CHANGE_TYPE': {
                'WithdrawalPoints': 'Списанные Баллы',
                'ReceivedPoints': 'Полученные Баллы'
            },
            'TRANSACTION_TYPES': {
                'BUY_SERVICE': 'Купить Электронные деньги',
                'SELL_SERVICE': 'Продать Электронные деньги',
                'EXCHANG_ESERVICE': 'Обмен Электронных денег',
                'DEPOSIT': 'Пополнение',
                'WITHDRAWAL': 'Списание',
                'BETWEEN_MY_WALLETS': 'Между Кошельками',
                'INTERNAL_TRANSFER': 'Внутренний перевод',
                'CHARGE_SMS_PANEL': 'Пополнить баланс для СМС',
                'WITHDRAWAL_POINT': 'Списание Баллов',
                'VOUCHER_SERVICE': 'Ваучер',
                'CHARGE_WALLET_CREDIT': 'Кредитное пополнение Кошелька',
                'TC_PAY_GATEWAY': 'Терминал оплаты ТС',
                Transition: 'Переход'
            },
            'NOTIFICATION_TYPE': {
                'Deposit': 'Пополнение',
                'Withdrawal': 'Списание',
                'Send': 'Перевод',
                'Receive': 'Получение',
                'Exchange': 'Обмен',
                'Point': 'Баллы',
                'Voucher': 'Ваучер',
                'RequestMessage': 'Сообщение в заявке',
                'Ticket': 'Обращение',
                'ExpertTicket': 'Обращение от Эксперта',
                'Friend': 'Друзья',
                'ContactUs': 'Свяжитесь с нами',
                'VerifyInfo': 'Верифицировать данные',
                'VerifyBankAccount': 'Верифицировать банковский счёт',
                'WalletChange': 'Кошелёк '
            },
            'REQUEST_TYPE_VALIDATION': {
                '0': 'Пополнение посредством Электронных денег',
                '1': 'Пополнение посредством валюты',
                '2': 'Обмен валюты',
                '3': 'Обмен Электронных денег',
                '4': 'Списание Баллов',
                '5': 'Отправка валюты',
                '6': 'Отправить со своего Кошелька',
                '7': 'Покупка Ваучера',
                '8': 'Списание Электронных денег',
                '9': 'Списание валюты'
            }
        },
        'VALIDATION': {
            'INVALID': '{{name}} недействителен',
            'MIN_LENGTH': 'Минимальное количество слов в ({{value}}) составляет {{name}}.',
            'MAX_LENGTH': 'Максимальное количество слов в ({{value}}) составляет {{name}}.',
            'AGREEMENT_REQUIRED': 'Пожалуйста, вначале подтвердите, что принимаете Правила сайта.',
            'NOT_FOUND': 'Указанная заявка не найдена',
            'REQUIRED': 'Строка {{name}} обязательна для заполнения',
            'INVALID_FIELD': 'Введённое значение недействительно для {{name}}.',
            'FILE_MAX_SIZE': 'Максимальный размер файла не должен превышать {{value}} Мгб.',
            'FILE_EXTENSION': 'Допустимые форматы',
            'SELECT': 'Выберите {{name}}'
        },
        USER: {
            'ACCOUNT': {
                'BANK': {
                    'NOTIFY': {
                        'NOTIFICATION': {
                            'TITLE': {
                                'BLOCKED': 'Банковский счёт',
                                'REJECTED': 'Банковский счёт',
                                'ACCEPTED': 'Банковский счёт'
                            },
                            'BODY': {
                                'BLOCKED': 'Ваш {{0}} счёт заблокирован.',
                                'REJECTED': 'Сведения Вашего {{0}} счёта отклонены.',
                                'ACCEPTED': 'Сведения Вашего {{0}} счёта подтверждены.'
                            }
                        }
                    }
                }
            },
            CREDIT: {
                POINT: {
                    NOTIFY: {
                        NOTIFICATION: {
                            TITLE: {
                                CORRECTION_DECREASE: "Сокращение баллов",
                                CORRECTION_INCREASE: "Добавление баллов"
                            },
                            BODY: {
                                CORRECTION_DECREASE: "В ходе корректировки от общего числа Ваших баллов вычтен балл",
                                CORRECTION_INCREASE: "В ходе корректировки к общему числу Ваших баллов добавлен балл"
                            }
                        }
                    }
                }
            }
        },
        FRIEND: {
            'NOTIFY': {
                'NOTIFICATION': {
                    'TITLE': {
                        'NEW_REQUEST': 'Заявка на дружбу',
                        'NEW_REQUEST_TO_NOT': 'Заявка на дружбу',
                        'ACCEPTED': 'Заявка на дружбу',
                        'REJECTED': 'Заявка на дружбу',
                        'CANCEL': 'Заявка на дружбу'
                    },
                    'BODY': {
                        'NEW_REQUEST': 'Вам отправлена новая заявка от {{0}}.',
                        'ACCEPTED': 'Ваша заявка на дружбу принята {{0}}.',
                        'REJECTED': 'Ваша заявка на дружбу отклонена {{0}}.',
                        'CANCEL': 'Ваша заявка на дружбу удалена {{0}}.'
                    }
                }
            }
        },
        WALLET: {
            'ACCOUNT_NUMBER': 'Номер счёта',
            'DIACTIVE': 'Деактивирован',
            'WALLET': 'Кошелёк',
            'WALLETS': 'Кошельки',
            'WALLET_TYPE': 'Вид Кошелька',
            'WHO_CAN_SEE_MY_WALLET': 'Кто может видеть мой Кошелёк',
            'CHOOSE_CURRENCY': 'Валюта',
            'TEXT': 'Текст',
            'TRANSIT': 'Транзитный Кошелёк',
            'SAVING': 'Сберегательный Кошелёк',
            'VIEW_FRIENDS': 'Друзья',
            'NOBODY': 'Никто',
            'EVERYONE': 'Все',
            'NEW_WALLET': 'Создать Кошелёк',
            'EDIT_WALLET': 'Редактировать Кошелёк',
            'EDIT_WALLETS': 'Редактировать Кошелёк',
            'TC_WALLETS': 'Кошелёк ТС',
            'TRANSACTIONS': 'Транзакции',
            'TRANSACTION_TYPE': 'Вид транзакции',
            'CHANGE_TYPE': 'Тип изменения',
            'SELECT_WALLET_FOR_REPORTING': 'Пожалуйста, вначале выберите Кошелёк',
            'SELECT_DATE_FOR_REPORTING': 'Пожалуйста, выберите, дату начала и окончания. Максимальный период составляет 31 день.',
            'LOCK_MESSAGE': 'Ваш Кошелёк заблокирован, для получения информации, пожалуйста, отправьте Обращение.',
            'SUPPORT_TICKET': 'Обращение Службы поддержки',
            'DESCRIPTION': 'Описание',
            'MY_WALLETS': 'Мои Кошельки',
            'SEEN_USER_REQURED': 'Пожалуйста, выберите, кто может видеть Ваш Кошелёк',
            'BALANCE': 'Остаток',
            CRYPTO_CURRENCIES: "Криптовалюты",
            CRYPTO_CURRENCY: "Криптовалюта",
            CRYPTO_WALLETS: "Криптовалютные Кошельки",
            FIAT: "Фиат",
            FIAT_WALLETS: "Фиатные Кошельки",
            WALLET_NAME: "Название Кошелька",
            ALERT: {
                SUCCESS_ADD: 'Кошелёк успешно создан',
                SUCCESS_EDIT: 'Редактирование Кошелька успешно выполнено.',
                CANT_USE_WALLET_FOR_INTERNAL_TANSFER: 'Вы не можете воспользоваться этим Кошельком для внутреннего перечисления',
                BALANCE_IS_LOW: 'Остаток Вашего Кошелька недостаточен',
                EXPORT_TRANSACTION_HINT: "Максимальный временной промежуток составляет 31 день"
            },
            NOTIFY: {
                NOTIFICATION: {
                    TITLE: {
                        'DECREASE': 'Остаток Кошелька сокращён',
                        'INCREASE': 'Остаток Кошелька пополнен'
                    },
                    BODY: {
                        'PG_DECREASE': 'Сумма в {{0}} списана с Кошелька {{1}} через Терминал ТС c номером отслеживания {{2}}.',
                        'PG_INCREASE': 'Сумма в {{0}} зачислена на Кошелёк {{1}} через Терминал ТС c номером отслеживания {{2}}.',
                        'CORRECTION_DECREASE': 'В ходе корректировки сумма в {{0}} списана с Кошелька {{1}}.',
                        'CORRECTION_INCREASE': 'В ходе корректировки сумма в {{0}} зачислена на Кошелёк {{1}}.'
                    }
                }
            }
        },
        SUPPORT: {
            'TICKET': {
                'NOTIFY': {
                    'NOTIFICATION': {
                        'TITLE': {
                            'CLOSED': 'Обращение',
                            'ADD_REPLY': 'Обращение',
                            'EXPERT_TICKET': 'Обращение Службы поддержки'
                        },
                        'BODY': {
                            'CLOSED': 'Обращение под номером {{0}} закрыто менеджером.',
                            'ADD_REPLY': 'Менеджер отправил новый ответ на Обращение под номером {{0}}.',
                            'EXPERT_TICKET': 'Менеджер отправил Вам Обращение.'
                        }
                    }
                }
            }
        }
    }
}


